// extracted by mini-css-extract-plugin
module.exports = {"root":"sharedStyles_root__fgk1x","rootTall":"sharedStyles_root--tall__2hWsc","fill":"sharedStyles_fill__3WXeu","stroke":"sharedStyles_stroke__nqZ8i"};